import type { JSX } from 'react';
import { PropsWithChildren } from 'react';

import { Props } from '@/ui/components/Form/Label/types';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const Label = ({
  children,
  className,
  htmlFor,
  reverse = false,
  text
}: PropsWithChildren<Props>): JSX.Element => {
  return (
    <label
      className={`block font-medium text-gray-700${className ? ` ${className}` : ''}`}
      htmlFor={htmlFor}>
      {reverse ? (
        <>
          {children}
          {text}
        </>
      ) : (
        <>
          {text}
          {children}
        </>
      )}
    </label>
  );
};

export default Label;
